import { baseApi } from '../baseApi';

export interface WeeklyTest {
  id: string;
  title: string;
  description?: string | null;
  testDate: string;
  timeLimit: number;
  totalMarks: number;
  passingMarks: number;
  isActive: boolean;
  academicYearId: string;
  classId: string;
  createdAt: string;
  academicYear?: { name: string };
}

export const weeklyTestApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getWeeklyTests: builder.query<{ success: boolean; data: WeeklyTest[]; total: number }, any>({
      query: (params) => ({
        url: '/api/weekly-tests',
        params,
      }),
      providesTags: ['WeeklyTest'],
    }),
    createWeeklyTest: builder.mutation<{ success: boolean; data: WeeklyTest }, Partial<WeeklyTest>>({
      query: (body) => ({
        url: '/api/weekly-tests',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['WeeklyTest', 'Dashboard'],
    }),
    updateWeeklyTest: builder.mutation<{ success: boolean; data: WeeklyTest }, { id: string; body: Partial<WeeklyTest> }>({
      query: ({ id, body }) => ({
        url: `/api/weekly-tests/${id}`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['WeeklyTest', 'Dashboard'],
    }),
    deleteWeeklyTest: builder.mutation<{ success: boolean; message: string }, string>({
      query: (id) => ({
        url: `/api/weekly-tests/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['WeeklyTest', 'Dashboard'],
    }),
  }),
});

export const {
  useGetWeeklyTestsQuery,
  useCreateWeeklyTestMutation,
  useUpdateWeeklyTestMutation,
  useDeleteWeeklyTestMutation,
} = weeklyTestApi;
